export type AtlasEnvironment = {
  key: string
  label: string
  host: string
}

// Staging is left out on purpose: Atlas watches the environments that carry customer traffic.
export const ATLAS_ENVIRONMENTS: AtlasEnvironment[] = [
  { key: 'prod', label: 'Production', host: 'app.wiseworks.ai' },
  { key: 'arendt', label: 'Arendt', host: 'arendt.wiseworks.ai' },
  { key: 'athora', label: 'Athora', host: 'athora.wiseworks.ai' },
  { key: 'aviva', label: 'Aviva', host: 'aviva.wiseworks.ai' },
  { key: 'eccles', label: 'Ecclesiastical', host: 'ecclesiastical.wiseworks.ai' },
  { key: 'schroders', label: 'Schroders', host: 'schroders.wiseworks.ai' },
  { key: 'sjp', label: 'SJP', host: 'sjp.wiseworks.ai' },
]
